import { render, staticRenderFns } from "./BoxName.vue?vue&type=template&id=02bb75b2&"
import script from "./BoxName.vue?vue&type=script&lang=ts&"
export * from "./BoxName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports